import React from 'react';

const PrivacyPolicy = () => {
    return (
        <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w-4xl mx-auto bg-white p-8 md:p-12 rounded-2xl shadow-xl">
                <h1 className="text-3xl font-bold mb-8 text-gray-900">Politica de Confidențialitate (GDPR)</h1>

                <div className="prose prose-blue max-w-none text-gray-600 space-y-6">
                    <p>
                        Ultima actualizare: {new Date().toLocaleDateString('ro-RO')}
                    </p>

                    <section>
                        <h2 className="text-xl font-semibold text-gray-800 mb-3">1. Introducere</h2>
                        <p>
                            Confidențialitatea datelor dumneavoastră este importantă pentru noi. Această politică explică modul în care colectăm, utilizăm și protejăm datele dumneavoastră cu caracter personal atunci când utilizați serviciile noastre, în conformitate cu Regulamentul General privind Protecția Datelor (GDPR).
                        </p>
                    </section>

                    <section>
                        <h2 className="text-xl font-semibold text-gray-800 mb-3">2. Datele colectate</h2>
                        <p>
                            Colectăm următoarele date personale prin intermediul formularelor noastre:
                        </p>
                        <ul className="list-disc pl-5 mt-2 space-y-1">
                            <li>Nume și prenume</li>
                            <li>Număr de telefon</li>
                            <li>Adresă de email (opțional)</li>
                            <li>Alte detalii furnizate voluntar în câmpurile formularului</li>
                            <li>Adresa IP și datele despre browser (pentru securitate și validare)</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-xl font-semibold text-gray-800 mb-3">3. Scopul prelucrării</h2>
                        <p>
                            Datele sunt colectate în scopul:
                        </p>
                        <ul className="list-disc pl-5 mt-2 space-y-1">
                            <li>Contactării dumneavoastră pentru a vă oferi informațiile sau serviciile solicitate.</li>
                            <li>Validării cererii și prevenirii fraudelor.</li>
                            <li>Îmbunătățirii serviciilor noastre.</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-xl font-semibold text-gray-800 mb-3">4. Drepturile dumneavoastră</h2>
                        <p>
                            Conform GDPR, aveți următoarele drepturi:
                        </p>
                        <ul className="list-disc pl-5 mt-2 space-y-1">
                            <li>Dreptul de acces la date.</li>
                            <li>Dreptul de rectificare sau ștergere a datelor ("dreptul de a fi uitat").</li>
                            <li>Dreptul de restricționare a prelucrării.</li>
                            <li>Dreptul la portabilitatea datelor.</li>
                            <li>Dreptul de opoziție.</li>
                        </ul>
                        <p className="mt-4">
                            Pentru exercitarea acestor drepturi, vă rugăm să ne contactați.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-xl font-semibold text-gray-800 mb-3">5. Securitatea datelor</h2>
                        <p>
                            Luăm măsuri tehnice și organizatorice adecvate pentru a proteja datele dumneavoastră împotriva accesului neautorizat, pierderii sau distrugerii.
                        </p>
                    </section>
                </div>

                <div className="mt-12 pt-8 border-t border-gray-100 text-center">
                    <button
                        onClick={() => window.close()}
                        className="px-6 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg transition-colors"
                    >
                        Închide pagina
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
